import { styled } from "../../../../../../../../../styles";
// Components

export const InformativeContainer = styled("div", {
  width: "100%",
  padding: "20px",
});
